import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const FlagDE: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 25 25"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M19.6992 8.03047L4.45357 10.2601L4.19539 10.2979L4.80755 14.5148L5.46946 14.418L20.3113 12.2474L19.6992 8.03047Z"
        fill="#FECA09"
      />
      <path
        d="M19.4926 4.79088L18.7877 4.89396L3.98965 7.05814L3.98877 7.05827L4.45357 10.2601L4.60093 11.2752L20.1047 9.00783L19.693 6.17141L19.4926 4.79088Z"
        fill="#E52521"
      />
      <path
        d="M4.80755 14.5148L4.19539 10.2979L4.45357 10.2601L3.98877 7.05827L3.98965 7.05814L3.70227 5.07848L4.06859 5.0249C3.99128 4.79595 3.7597 4.64813 3.51305 4.68497C3.24817 4.72454 3.0617 4.96275 3.08137 5.22658L3.18111 5.90862L4.5914 15.4208L5.59618 15.2727L5.46946 14.418L4.80755 14.5148Z"
        fill="#050506"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4.67012L19.4275 2.25L21 13.0034L5.59618 15.2727L5.46946 14.418L4.80755 14.5148L4.19539 10.2979L4.45357 10.2601L3.98877 7.05827L3.98965 7.05814L3.70227 5.07848L4.06859 5.0249C4.07822 5.05343 4.08546 5.08322 4.09003 5.11406L4.18574 5.75959L4.15225 5.53061L18.5702 3.40654L18.7877 4.89396L19.4926 4.79088L19.693 6.17141L19.6938 6.17128L19.2061 2.81108L4.06859 5.0249C3.99128 4.79595 3.7597 4.64813 3.51305 4.68497C3.24817 4.72454 3.0617 4.96275 3.08137 5.22658L3 4.67012ZM3.18111 5.90862L3.08555 5.2641C3.08369 5.25155 3.0823 5.23903 3.08137 5.22658L3.18111 5.90862ZM4.5914 15.4208L4.57249 15.4235L3.18111 5.90862L4.5914 15.4208ZM4.5914 15.4208L5.46535 21.3153C5.50662 21.5937 5.76495 21.7858 6.04233 21.7444C6.31971 21.7029 6.5111 21.4437 6.46983 21.1653L5.59618 15.2727L4.5914 15.4208ZM4.57461 8.38244L18.9896 6.27428L19.8477 12.1429L5.4467 14.2645L4.57461 8.38244Z"
        fill="#050506"
      />
      <path
        d="M19.6938 6.17128L19.2061 2.81108L4.06859 5.0249C4.07822 5.05343 4.08546 5.08322 4.09003 5.11406L4.18574 5.75959L4.15225 5.53061L18.5702 3.40654L18.7877 4.89396L19.4926 4.79088L19.693 6.17141L19.6938 6.17128Z"
        fill="#050506"
      />
    </svg>
  );
};

export default FlagDE;
